import ZoomMtgEmbedded from '@zoom/meetingsdk/embedded';
import { useEffect, useState } from 'react';
import { css, createGlobalStyle } from 'styled-components';

import { zIndices } from '@hivebrite/design-system/Theme';
import { Box } from '@hivebrite/design-system/Box';
import { Loader } from '@hivebrite/design-system/Loader';

import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

const GlobalStyle = createGlobalStyle`
  [role='dialog'] {
    z-index: ${zIndices.popover};
  }
`;

const EventZoomClient = ({ eventId }) => {
  const [meetingData, setMeetingData] = useState(null);
  const [zoomReady, setZoomReady] = useState(false);
  const joinMeeting = (client) => {
    const args = { eventId };

    window.location.hash = '';
    axios.get(Routes.zoom_signature_path(args)).then(({ data }) => {
      setMeetingData(data);

      const clientJoinData = {
        signature: data.signature,
        meetingNumber: data.meetConfig.meetingNumber,
        password: data.meetConfig.passWord,
        userName: data.meetConfig.userName,
        userEmail: data.meetConfig.userEmail,
      };

      // We either use sdkKey or apiKey ( prior to zoom 2.7.0 ), we cannot use both at the same time or else Zoom crashes.
      if (data.meetConfig.sdkKey) {
        clientJoinData.sdkKey = data.meetConfig.sdkKey;
      } else {
        clientJoinData.apiKey = data.meetConfig.apiKey;
      }

      client.join(clientJoinData);
    });
  };

  const createClient = () => {
    const meetingSDKElement = document.getElementById('meetingSDKElement');
    const client = ZoomMtgEmbedded.createClient();

    client.init({
      debug: false,
      zoomAppRoot: meetingSDKElement,
      customize: {
        meetingInfo: [
          'topic',
          'host',
          'mn',
          'pwd',
          'telPwd',
          'invite',
          'participant',
          'dc',
          'enctype',
        ],
        video: { viewSizes: { default: { height: 400, width: 600 } } },
        viewSizes: { default: { height: 400, width: 600 } },
      },
    });
    setZoomReady(true);

    return client;
  };

  useEffect(() => {
    if (!zoomReady) {
      const client = createClient();

      joinMeeting(client);
    }
  }, [meetingData, zoomReady]);

  return (
    <>
      <GlobalStyle />
      {!zoomReady && <Loader small={false} />}
      <Box
        ml={-6}
        id="meetingSDKElement"
        css={css`
          display: ${!zoomReady ? 'none' : undefined};
          height: 600px;
          width: 100%;
        `}
      />
    </>
  );
};

export default EventZoomClient;
